// extracted by mini-css-extract-plugin
export default {"font-renta":"AddWorkReportAttachmentModal_font-renta__CWggo"};